import { cn, Icon, Typography } from "@vintecc/components";
import { FC, PropsWithChildren, ReactNode } from "react";
import { useCommonTranslation } from "@/services/culture/common.translations";

import { faClose } from "@vintecc/pro-light-svg-icons";

export interface PanelHeaderProps extends PropsWithChildren {
  title: string;
  onClose?: () => void;
  icon?: ReactNode;
  className?: string;
  testId?: string;
  closeButtonTestId?: string;
}

export const PanelHeader: FC<PanelHeaderProps> = ({ onClose, icon, title, className, children, testId, closeButtonTestId }) => {
  const { t } = useCommonTranslation();

  return (
    <div
      className={cn("pl-8 pr-4 py-5 border-b border-grey-200", className)}
      data-testid={testId}
      style={{ background: "linear-gradient(308.68deg, #FFFFFF 49.8%, #F7F7F7 88.54%)" }}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-1">
          {icon && <div className="flex justify-center items-center h-5 w-5">{icon}</div>}
          <Typography variant="strong">{title}</Typography>
        </div>
        {onClose && (
          <button
            type="button"
            className="flex justify-center items-center w-8 h-7 cursor-pointer text-grey-600"
            onClick={onClose}
            aria-label={t("common.close")}
            data-testid={closeButtonTestId}
          >
            <Icon icon={faClose} size="2xl" />
          </button>
        )}
      </div>
      {children}
    </div>
  );
};
